import { render, staticRenderFns } from "./DebugTile.vue?vue&type=template&id=997610e8&scoped=true&functional=true"
import script from "./DebugTile.vue?vue&type=script&lang=ts"
export * from "./DebugTile.vue?vue&type=script&lang=ts"
import style0 from "./DebugTile.vue?vue&type=style&index=0&id=997610e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "997610e8",
  null
  
)

export default component.exports